<template>
  <div class="popup">
    <div class="popup-title">
      <span>
        {{ currentStep.title }}
      </span>
      <button class="btn btn-common" @click.stop="close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.35355 1.64645C2.15829 1.45118 1.84171 1.45118 1.64645 1.64645C1.45118 1.84171 1.45118 2.15829 1.64645 2.35355L7.29289 8L1.64645 13.6464C1.45118 13.8417 1.45118 14.1583 1.64645 14.3536C1.84171 14.5488 2.15829 14.5488 2.35355 14.3536L8 8.70711L13.6464 14.3536C13.8417 14.5488 14.1583 14.5488 14.3536 14.3536C14.5488 14.1583 14.5488 13.8417 14.3536 13.6464L8.70711 8L14.3536 2.35355C14.5488 2.15829 14.5488 1.84171 14.3536 1.64645C14.1583 1.45118 13.8417 1.45118 13.6464 1.64645L8 7.29289L2.35355 1.64645Z"
            fill="#E2E2E2" />
        </svg>
      </button>
    </div>
    <div class="popup-content">
      {{ currentStep.content }}
    </div>
    <div class="arrow">
      <svg
        style="display: inline; vertical-align: unset"
        width="8"
        height="16"
        viewBox="0 0 8 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 0L8 8L8 16L0.707106 8.70711C0.316581 8.31658 0.316582 7.68342 0.707106 7.29289L8 0Z"
          fill="#323232" />
      </svg>
    </div>
    <div class="popup-footer">
      <div class="popup-footer-step">{{ step }} of 3</div>
      <button class="btn btn-next" @click.stop="next">
        {{ textBtn }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { app } from '@/store';
import { cloneDeep } from '@/utils/common';

export default {
  name: 'PopupStepOnBoarding',
  props: {
    step: {
      type: Number,
    },
  },
  data: function () {
    return {
      scripts: [
        {
          step: 1,
          key: 'color',
          title: this.$t('sidebarGS.presetDetail.colorStyleTooltip.title'),
          content: this.$t('sidebarGS.presetDetail.colorStyleTooltip.desc'),
        },
        {
          step: 2,
          key: 'text',
          title: this.$t('sidebarGS.presetDetail.textStyleTooltip.title'),
          content: this.$t('sidebarGS.presetDetail.textStyleTooltip.desc'),
        },
        {
          step: 3,
          key: 'button',
          title: this.$t('sidebarGS.presetDetail.buttonStyleTooltip.title'),
          content: this.$t('sidebarGS.presetDetail.buttonStyleTooltip.desc'),
        },
      ],
    };
  },
  computed: {
    ...mapState('app', {
      shopMeta: 'shopMeta',
    }),
    obGlobalStyle() {
      return this.shopMeta.onboardingGlobalStyle;
    },
    currentStep() {
      return this.scripts.find((script) => script.step === this.step);
    },
    textBtn() {
      if (this.step <= 2) return 'Next';
      return 'Got it';
    },
  },
  created() {
    if (this.shopMeta.onboardingGlobalStyle.firstViewListPack || window.blockUpdateShopMeta) {
      return;
    }

    const payload = cloneDeep(this.shopMeta);
    payload.onboardingGlobalStyle.firstViewListPack = true;

    this.updateShopMeta(payload);
    window.blockUpdateShopMeta = true;
  },

  unmounted() {
    if (this.shopMeta.onboardingGlobalStyle.firstViewListPack) {
      return;
    }

    this.closePopupStepOB();
  },
  methods: {
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    closePopupStepOB() {
      const shopMeta = app.$store.state['app']['shopMeta'];
      shopMeta['onboardingGlobalStyle']['firstViewListPack'] = true;
    },
    next() {
      if (this.step === 3) {
        return this.closePopupStepOB();
      }
      return this.$emit('next');
    },
    close() {
      this.closePopupStepOB();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  width: 294px;
  background: #323232;
  border-radius: 3px;
  position: absolute;
  right: -313px;
  top: -30px;

  .arrow {
    position: absolute;
    top: 43px;
    left: -7px;
  }

  .btn-common {
    display: flex;
    background: none;
    top: 16px;
    right: 0;
  }

  &-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-next {
      background: #3c67ff;
      margin-right: 12px;
      margin-bottom: 20px;
    }

    &-step {
      margin-left: 12px;
      margin-bottom: 20px;
      color: #aaaaaa;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
    }
  }

  &-title {
    color: #8aa4ff;
    font-size: 16px;
    line-height: 150%;
    font-style: normal;
    font-weight: 500;
    margin: 14px 0 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-content {
    color: #e2e2e2;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    margin: 0 2px 14px 16px;
  }
}
</style>
